export const relatedDramas = [
  {
    id: "rel-01",
    title: "春夜的信",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20korean%20drama%20poster%20of%20a%20young%20woman%20standing%20under%20spring%20blossom%20trees%20at%20dusk%2C%20soft%20pink%20and%20amber%20tones%2C%20romantic%20melancholic%20mood%2C%20professional%20photography%2C%20high%20detail%2C%20subtle%20film%20grain&width=600&height=800&seq=rel-01-cover&orientation=portrait",
    genre: "爱情",
    year: 2025,
    rating: 8.4,
    duration: "16集 / 全",
    summary: "一封跨越十年的信，让两条错过的平行线重新交汇。",
  },
  {
    id: "rel-02",
    title: "妈妈的厨房",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20korean%20drama%20poster%20of%20a%20warm%20cozy%20kitchen%20with%20steaming%20home%20cooking%20and%20soft%20lamp%20light%2C%20amber%20tones%2C%20tender%20nostalgic%20mood%2C%20professional%20photography%2C%20high%20detail%2C%20subtle%20film%20grain&width=600&height=800&seq=rel-02-cover&orientation=portrait",
    genre: "家庭",
    year: 2024,
    rating: 9.0,
    duration: "24集 / 全",
    summary: "一间老旧厨房，装下了三代人的思念与和解。",
  },
  {
    id: "rel-03",
    title: "归途",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20korean%20drama%20poster%20of%20a%20man%20with%20a%20backpack%20walking%20along%20a%20rural%20road%20toward%20an%20old%20village%20at%20sunset%2C%20warm%20amber%20tones%2C%20wistful%20mood%2C%20professional%20photography%2C%20high%20detail%2C%20subtle%20film%20grain&width=600&height=800&seq=rel-03-cover&orientation=portrait",
    genre: "剧情",
    year: 2025,
    rating: 8.2,
    duration: "20集 / 全",
    summary: "离乡多年的人，总要在某个黄昏走回那条熟悉的路。",
  },
  {
    id: "rel-04",
    title: "海边来信",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20korean%20drama%20poster%20of%20a%20quiet%20seaside%20pier%20at%20blue%20hour%20with%20a%20lone%20figure%2C%20soft%20teal%20and%20amber%20tones%2C%20contemplative%20mood%2C%20professional%20photography%2C%20high%20detail%2C%20subtle%20film%20grain&width=600&height=800&seq=rel-04-cover&orientation=portrait",
    genre: "治愈",
    year: 2023,
    rating: 8.7,
    duration: "12集 / 全",
    summary: "离开城市的人在海边小镇，重新学会了如何生活。",
  },
  {
    id: "rel-05",
    title: "倒带人生",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20korean%20drama%20poster%20of%20an%20old%20film%20camera%20and%20scattered%20photographs%20on%20a%20wooden%20desk%2C%20warm%20amber%20tones%2C%20reflective%20nostalgic%20mood%2C%20professional%20photography%2C%20high%20detail%2C%20subtle%20film%20grain&width=600&height=800&seq=rel-05-cover&orientation=portrait",
    genre: "剧情",
    year: 2024,
    rating: 8.1,
    duration: "18集 / 全",
    summary: "如果时间可以倒带，你最想回去改写哪一个瞬间？",
  },
  {
    id: "rel-06",
    title: "我们的夏天",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20korean%20drama%20poster%20of%20young%20friends%20cycling%20through%20a%20sunlit%20green%20field%20in%20summer%2C%20warm%20yellow%20green%20tones%2C%20joyful%20youthful%20mood%2C%20professional%20photography%2C%20high%20detail%2C%20subtle%20film%20grain&width=600&height=800&seq=rel-06-cover&orientation=portrait",
    genre: "青春",
    year: 2025,
    rating: 8.5,
    duration: "16集 / 全",
    summary: "那个夏天之后，我们都变成了更好的大人。",
  },
  {
    id: "rel-07",
    title: "旧屋",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20korean%20drama%20poster%20of%20a%20weathered%20old%20wooden%20house%20surrounded%20by%20trees%20at%20dusk%2C%20warm%20amber%20tones%2C%20lonely%20nostalgic%20mood%2C%20professional%20photography%2C%20high%20detail%2C%20subtle%20film%20grain&width=600&height=800&seq=rel-07-cover&orientation=portrait",
    genre: "家庭",
    year: 2024,
    rating: 8.9,
    duration: "22集 / 全",
    summary: "老屋要拆了，散落各地的家人最后一次聚在一起。",
  },
  {
    id: "rel-08",
    title: "微光",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20korean%20drama%20poster%20of%20a%20single%20warm%20lamp%20glowing%20in%20a%20dark%20quiet%20room%20window%20at%20night%2C%20deep%20blue%20and%20amber%20tones%2C%20hopeful%20quiet%20mood%2C%20professional%20photography%2C%20high%20detail%2C%20subtle%20film%20grain&width=600&height=800&seq=rel-08-cover&orientation=portrait",
    genre: "治愈",
    year: 2026,
    rating: 8.3,
    duration: "14集 / 更新中",
    summary: "再微弱的光，也足以照亮一个人前行的路。",
  },
];

export const relatedGenres = ["全部", "家庭", "爱情", "治愈", "剧情", "青春"];
export const relatedYears = ["全部", "2026", "2025", "2024", "2023"];
export const relatedRatings = ["全部", "9.0分以上", "8.5分以上", "8.0分以上"];

export default relatedDramas;